<template>
    <div class="modal-content m-modalPromoAccept modal--accept modal-labels">
        <div class="modal-header text-center">
            <modal-close
                :on-close="cancel"
                :confirmation="confirmationWindowConfig"
            />
            <div class="modal-title mb-0 mb-md-2">
                <h2 v-text="modalTitle" class="h3 m-0" />
            </div>
            <div v-if="filterSelectedMerchants.length">
                Tworzenie w
                {{
                    filterSelectedMerchants.length
                        | plurals('sklepie', 'sklepach')
                }}
                <span
                    class="cursor-pointer"
                    @click="
                        $store.dispatch('setFilter', {
                            filter: 'promo|subscription|merchant_id',
                            value: [],
                            moduleName: 'labelGroups'
                        })
                    "
                >
                    [wyczyść filtr]
                </span>
            </div>
        </div>
        <template v-if="step === 1">
            <div class="modal-body t-promos p-3">
                <page-preloader min-height="4rem" v-if="!productsFetched" />
                <template v-else>
                    <div
                        v-for="(group, gIdx) in labelGroups"
                        class="t-promo-group promo-group d-flex flex-column"
                        :key="`group-${group.id}`"
                        :id="`group-${group.id}`"
                    >
                        <div class="m-modalPromoAccept__groupHeader --labels">
                            <div class="t-promo-group__details">
                                <h4>{{ group.name }}</h4>
                                <div class="text-primary font-weight-bold">
                                    wybrano
                                    <template v-if="group.countPromos">
                                        <span
                                            class="text-dark"
                                            v-text="group.selectedPromoIds.length"
                                        />
                                        z
                                        <span class="text-dark">
                                            {{ group.countPromos }}
                                        </span>
                                        promocji
                                    </template>
                                    <template v-else>
                                        {{
                                            group.selectedPromoIds.length
                                                | plurals(
                                                    'promocję',
                                                    'promocje',
                                                    'promocji'
                                                )
                                        }}
                                    </template>
                                </div>
                            </div>
                            <div class="t-promo-group__actions d-flex gap-0-5">
                                <the-btn
                                    class="btn-custom-gray btn-block"
                                    @click.native="onShowHidePromosClick(group)"
                                >
                                    <a-icon
                                        :icon="
                                            group.showPromosOnLabelsGenerateView
                                                ? 'ArrowUp'
                                                : 'ArrowDown'
                                        "
                                        width="16px"
                                        class="mr-1"
                                    />
                                    Pokaż promocje
                                </the-btn>
                                <the-btn
                                    class="btn-custom-gray py-1"
                                    @click.native="onGroupDelete(group)"
                                >
                                    <a-icon icon="Bin" width="16px" />
                                </the-btn>
                            </div>
                        </div>
                        <div
                            v-if="showMandatoryPriceGroupWarning(group)"
                            class="a-infoBar a-infoBar--warning a-infoBar--noBorder a-infoBar--left"
                        >
                            Rozwiń promocje i sprawdź, w których brakuje cen omnibus
                            oraz/lub cen poza promocją
                        </div>
                        <div v-if="group.showPromosOnLabelsGenerateView">
                            <div role="promos">
                                <promotion-preview
                                    v-for="(promotion,id) in filteredSelectedLabels(group)"
                                    :key="`new-${id}`"
                                    :group-id="group.id"
                                    preview-type="labels"
                                    :promotion="promotion"
                                    :acceptance="group.acceptance"
                                >
                                    <template #promotionShops>
                                        <promotion-shops
                                            :group-id="group.id"
                                            :key="promotion.id"
                                            :price-group-idx="gIdx"
                                            :promotion="promotion"
                                            :merchants="merchants"
                                            :active-promo="promotion.id"
                                            preview-type="labels"
                                            @onChangeActivePromo="
                                                activePromo = $event
                                            "
                                            :from-single-promo="true"
                                        />
                                    </template>
                                </promotion-preview>
                            </div>
                        </div>
                        <page-preloader
                            v-if="group.status === 'loading'"
                            min-height="220px"
                        />
                        <the-btn
                            v-if="showDownloadMorePromosButton(group)"
                            class="btn-custom-gray w-100 mt-3"
                            text="Pokaż kolejne promocje z grupy"
                            @click="loadMorePromos(group)"
                        />
                        <div
                            v-if="isBtnCollapseVisible(group)"
                            role="collapse"
                            class="btn-collapse w-100 mt-3 mx-auto"
                        >
                            <the-btn
                                class="btn-custom-gray w-100 mx-auto"
                                @click.native="collapseGroup(group)"
                            >
                                Zwiń grupę
                            </the-btn>
                        </div>
                    </div>
                </template>
            </div>
            <div class="modal-footer pt-2 m-labels__footer">
                <div
                    v-if="regularEansPricesActive"
                    class="m-labels__footerRegularPriceWrapper"
                >
                    <div
                        v-if="allLabelsRequestedRegularPrice"
                        class="d-flex align-items-center"
                    >
                        <div
                            v-if="someLabelsHasNotRegularPrice"
                            class="d-flex align-items-center"
                        >
                            <a-icon icon="Warning" class="text-warning" />
                            <span class="ml-3">
                                Brak możliwości pobrania ceny poza promocją dla niektórych promocji
                            </span>
                        </div>
                        <div v-else class="d-flex align-items-center">
                            <a-icon icon="Check" class="text-success" />
                            <span class="ml-3">
                                Pobrano ceny poza promocją dla wszystkich promocji
                            </span>
                        </div>
                    </div>
                    <the-btn
                        v-else-if="this.$brand.labels.isRegularEanPriceDownload"
                        v-tooltip="{
                            content: `Jeśli cena produktu uległa ostatnio zmianie,
                                nasza podpowiedź może być nieprecyzyjna.`
                        }"
                        class="btn-generate-labels btn btn-outline-custom ml-auto -wrap btn-block"
                        :class="{
                            disabled: regularPricesDownloadState === 'pending'
                        }"
                        text="Pobierz paragonowe ceny poza promocją dla wszystkich promocji"
                        icon="Download"
                        :loading-status="
                            regularPricesDownloadState === 'pending'
                                ? 'loading' : 'idle'
                        "
                        @click.native="onPricesDownload"
                    >
                    </the-btn>
                </div>
                <div class="m-labels__footerButtonWrapper">
                    <m-confirm
                        v-if="confirmMessages.length > 0"
                        :messages="confirmMessages"
                        :abort-btn-class="'btn btn-sm btn-outline-custom'"
                        :is-disabled="!acceptLabelsButtonEnabled"
                        @click.native="validateWeightPromos"
                        @onConfirm="acceptLabels"
                        @onAbort="abortLabels"
                        @onClick="checkPromosWithMandatoryPrice"
                        @onChangeMsgIdx="onChangeMsgIdx"
                    />
                    <button
                        v-else
                        class="btn-generate-labels btn btn-secondary ml-auto btn-block"
                        @click="acceptLabels"
                        :disabled="!acceptLabelsButtonEnabled"
                    >
                        Przejdź dalej
                    </button>
                </div>
            </div>
        </template>
        <template v-if="step === 2">
            <div class="modal-body">
                <div class="progress">
                    <div
                        v-for="(row, key) in selectedLabels"
                        :key="key"
                        class="progress-bar"
                        :class="{ 'bg-success': row.accepted }"
                        role="progressbar"
                        :style="`width: ${(1 / selectedLabels.length) * 100}%`"
                        :aria-valuenow="
                            `${((1 / selectedLabels.length) * 100).toFixed(0)}`
                        "
                        aria-valuemin="0"
                        aria-valuemax="100"
                    ></div>
                </div>

                <div v-if="active">
                    <span class="m-labels__title">Wybrana promocja:</span>

                    <div class="m-labels__labelHeader">
                        <div class="d-flex m-labels__imageTitleWrapper">
                            <div class="c-fig c-fig--promos c-fig--product">
                                <img
                                    :src="
                                        active.logo &&
                                            active.logo.urls &&
                                            active.logo.urls.small
                                    "
                                    class="c-fig__img"
                                    alt
                                />
                            </div>
                            <h3 class="richTable-title mb-0 ml-3">
                                {{ active.name }}
                            </h3>
                        </div>
                        <div class="m-labels__regularPriceWrapper">
                            <div
                                v-if="
                                    allProductsSetsRegularPrice &&
                                        active.noRegularPriceInSomeProducts ===
                                        false
                                "
                                class="d-flex align-items-center"
                            >
                                <a-icon icon="Check" class="text-success" />
                                <span class="ml-3">
                                    Pobrano ceny poza promocją
                                </span>
                            </div>
                            <div
                                v-else-if="
                                    !active.noRegularPriceInAllProducts &&
                                        active.noRegularPriceInSomeProducts ===
                                        true
                                "
                                class="d-flex align-items-center"
                            >
                                <a-icon icon="Warning" class="text-warning" />
                                <span class="ml-3">
                                    Brak możliwości pobrania ceny poza
                                    promocją dla niektórych pozycji
                                </span>
                            </div>

                            <div
                                v-else-if="
                                    activeLabelAllProductsHasNotRegularPrice
                                "
                                class="d-flex align-items-center"
                            >
                                <a-icon icon="Warning" class="text-warning" />
                                <span class="ml-3">
                                    Brak możliwości pobrania ceny poza promocją
                                </span>
                            </div>
                            <div
                                v-else-if="
                                    this.$brand.labels.isRegularEanPriceDownload
                                "
                            >
                                <the-btn
                                    v-tooltip="{
                                        content: `Jeśli cena produktu uległa ostatnio zmianie,
                                            nasza podpowiedź może być nieprecyzyjna.`
                                    }"
                                    class="btn-generate-labels btn btn-outline-custom ml-auto "
                                    :class="{
                                        disabled:
                                            regularPricesDownloadState ===
                                            'pending'
                                    }"
                                    text="Pobierz paragonowe ceny poza promocją"
                                    icon="Download"
                                    :loading-status="
                                        singleLabelRegularPriceRequestPending
                                            ? 'loading' : 'idle'
                                    "
                                    @click.native="onSinglePromoPricesDownload"
                                />
                            </div>
                        </div>
                    </div>

                    <hr />

                    <span class="m-labels__title">Wybierz produkty:</span>
                    <div
                        class="m-labels__products"
                        :key="regularPricesDownloadState"
                    >
                        <label-product
                            v-for="(product, pKey) in active.labels"
                            :key="`product-${pKey}`"
                            :product="product"
                            :p-key="+pKey"
                            :promo-id="active.id"
                            :active-key="activeKey"
                            :promo="active"
                        ></label-product>
                    </div>
                </div>
            </div>
            <div class="modal-footer pt-2 ">
                <p>
                    Wybranych produktów:
                    <span class="text-primary">
                        {{
                            Object.values(active.labels).filter(
                                label => label.downloadLabel
                            ).length
                        }}
                    </span>
                </p>

                <button
                    class="btn btn-outline-custom mt-2 mt-lg-0"
                    @click.prevent="cancel"
                >
                    Anuluj
                </button>

                <button
                    @mouseenter="goNextBtnHover"
                    class="btn btn-secondary mt-2 mt-lg-0"
                    :class="{ disabled: !enableSave }"
                    @click.prevent="saveLabels()"
                    v-tooltip="{
                        content: noLabelsSelectedInActivePromoText
                    }"
                >
                    Dalej
                </button>
            </div>
        </template>
        <page-preloader
            class="auto-height"
            mode="wrapper"
            :is-loading="downloadStatus === 'loading' && step === 3"
        >
            <template
                v-if="downloadStatus === 'loading' && step === 3"
                v-slot:loaderDescription
            >
                <div class="p-4 text-center">
                    <h5>Trwa generowanie cenówek. Nie zamykaj okna.</h5>
                </div>

                <the-hints
                    class="mb-3 md-sm-0 --bgWhite w-100 px-3 mb-4"
                    snippet-code="snippet004"
                ></the-hints>
            </template>
            <template v-if="downloadStatus === 'no_found' && step === 3">
                <div class="modal-body text-center p-4">
                    <a-icon
                        icon="ErrorCircle"
                        width="50px"
                        height="50px"
                        class="mb-4"
                    />
                    <h5 class="font-weight-normal">
                        Wygenerowanie wybranego rodzaju materiału dla tego typu promocji
                        nie jest możliwe. Przepraszamy za utrudnienia.
                    </h5>
                </div>
                <div class="modal-footer border-top-1 d-flex">
                    <button
                        v-text="'Wróć'"
                        class="btn btn-outline btn-block"
                        @click="$store.dispatch('resetDownloadLabelGroupsStatus')"
                    />
                    <the-btn
                        class="btn btn-secondary ml-auto"
                        id="cancel-labels-btn"
                        text="Przejdź do zakładki Cenówki"
                        @click="cancel"
                    />
                </div>
            </template>
            <template v-else-if="step === 3">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="m-labels__title">Wybierz format:</div>
                            <div class="form-group">
                                <ui-checkbox-input
                                    v-model="labelTypeNormal"
                                    radio-type
                                    class="custom-control custom-checkbox"
                                    label="Cenówki"
                                    name="type-normal"
                                    :tooltip="formatCheckboxTooltipText('normal')"
                                />
                            </div>
                            <div class="form-group">
                                <ui-checkbox-input
                                    v-model="labelTypeLarge"
                                    radio-type
                                    class="custom-control custom-checkbox"
                                    label="Plakaty"
                                    name="type-large"
                                    :tooltip="formatCheckboxTooltipText('large')"
                                />
                            </div>
                            <div class="form-group">
                                <ui-checkbox-input
                                    v-model="labelTypeLargeColor"
                                    radio-type
                                    class="custom-control custom-checkbox"
                                    label="Plakaty kolorowe"
                                    name="type-large2"
                                    :tooltip="formatCheckboxTooltipText('large2')"
                                />
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="m-labels__title">Wybierz metodę:</div>

                            <div class="form-group">
                                <ui-checkbox-input
                                    class="custom-control custom-checkbox"
                                    label="Wysyłka"
                                    name="method-send"
                                    v-model="methodSend"
                                />
                            </div>
                            <div class="form-group">
                                <ui-checkbox-input
                                    class="custom-control custom-checkbox"
                                    label="Drukowanie"
                                    name="method-print"
                                    v-model="methodPrint"
                                />
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="m-labels__title">Opcje:</div>

                            <div class="form-group">
                                <ui-checkbox-input
                                    class="custom-control custom-checkbox"
                                    label="Linie cięcia"
                                    name="guides"
                                    v-model="labelGuides"
                                />
                            </div>
                            <div class="form-group">
                                <ui-checkbox-input
                                    class="custom-control custom-checkbox"
                                    label="Nazwa sklepu"
                                    name="merchant-header"
                                    v-model="labelMerchantHeader"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer border-top-1 d-flex">
                    <button
                        class="btn btn-outline btn-block"
                        @click.prevent="step = 1"
                        :disabled="downloadStatus === 'loading'"
                    >
                        Wróć
                    </button>
                    <the-btn
                        v-if="methodPrint"
                        class="btn btn-secondary ml-auto"
                        id="download-labels-btn"
                        text="Pobierz"
                        icon="Download"
                        :loading-status="downloadStatus"
                        @click.native="downloadLabels"
                    />
                    <button
                        v-if="methodSend"
                        class="btn btn-secondary ml-auto flex-1"
                        @click.prevent="chooseSend"
                    >
                        Zdefiniuj odbiorców
                    </button>
                </div>
            </template>
        </page-preloader>
        <template v-if="step === 4">
            <div class="modal-body">
                <p>
                    Wybierz Managerów sklepów, do których chcesz wysłać cenówki
                </p>
                <div class="richTable is-simple text-left">
                    <div class="richTable-head">
                        <div class="richTable-head-col" style="--width-md: 30%">
                            Nazwa sklepu
                        </div>
                        <div class="richTable-head-col" style="--width-md: 20%">
                            Osoba kontaktowa
                        </div>
                        <div class="richTable-head-col" style="--width-md: 30%">
                            Adres e-mail
                        </div>
                        <div
                            class="richTable-head-col d-flex justify-content-end"
                            style="--width-md: 20%"
                        >
                            <span class="mr-1">Wszystkie</span>
                            <div class="form-check form-check-inline">
                                <div>
                                    <ui-checkbox-input
                                        name="select-all-shops"
                                        @change="selectAllShops"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="richTable-body">
                        <label-shop
                            v-for="(merchant, idx) in merchants"
                            :data="merchant"
                            :key="idx"
                        />
                    </div>
                </div>
            </div>
            <div class="modal-footer d-flex">
                <button
                    class="btn btn-outline btn-block"
                    @click.prevent="step = 3"
                >
                    Wróć
                </button>
                <button
                    class="btn btn-secondary"
                    :class="{ disabled: !enableSendButton }"
                    @click.prevent="sendLabels"
                >
                    {{ methodText }}
                </button>
            </div>
        </template>
        <page-preloader
            mode="wrapper"
            :is-loading="downloadStatus === 'loading' && step === 5"
        >
            <template
                v-if="downloadStatus === 'loading' && step === 5"
                v-slot:loaderDescription
            >
                <div class="p-4 text-center">
                    <h5>Trwa generowanie cenówek. Nie zamykaj okna.</h5>
                </div>
            </template>
            <template v-if="downloadStatus === 'no_found' && step === 5">
                <div class="modal-body text-center p-4">
                    <a-icon
                        icon="ErrorCircle"
                        width="50px"
                        height="50px"
                        class="mb-4"
                    />
                    <h5 class="font-weight-normal">
                        Wygenerowanie wybranego rodzaju materiału dla tego typu promocji
                        nie jest możliwe. Przepraszamy za utrudnienia.
                    </h5>
                </div>
                <div class="modal-footer border-top-1 d-flex">
                    <button
                        v-text="'Wróć'"
                        class="btn btn-outline btn-block"
                        @click="$store.dispatch('resetDownloadLabelGroupsStatus')"
                    />
                    <the-btn
                        class="btn btn-secondary ml-auto"
                        id="cancel-labels-btn"
                        text="Przejdź do zakładki Cenówki"
                        @click="cancel"
                    />
                </div>
            </template>
            <template v-else-if="step === 5">
                <div class="modal-body text-center">
                    <h2 class="h3 px-2 pt-3 pb-2">Świetnie!</h2>
                    <p>
                        Cenówki zostały wysłane do sklepów, dla których wskazane
                        promocje są aktywne.
                    </p>
                    <img
                        class="my-4"
                        :src="require('@/assets/img/labels-thank-you.svg')"
                    />
                    <br />
                    <div class="row">
                        <div class="col-sm-6 col-12">
                            <button
                                @click="
                                    cancel
                                    $store.dispatch('toggleModal', false)
                                "
                                class="mt-2 btn btn-secondary btn-block"
                                data-dismiss="modal"
                            >
                                Powrót do cenówek
                            </button>
                        </div>
                        <div class="col-sm-6 col-12">
                            <the-btn
                                class="mt-2 btn btn-secondary btn-block"
                                data-dismiss="modal"
                                text="Pobierz cenówki"
                                icon="Download"
                                :loading-status="downloadStatus"
                                @click.native="downloadLabels"
                            />
                        </div>
                    </div>
                </div>
            </template>
        </page-preloader>
    </div>
</template>

<script>
import LabelProduct from '@/components/labels/LabelProduct'
import LabelShop from '@/components/labels/LabelShop'
import { UiCheckboxInput } from '../global/ui'
import PromotionPreview from '@/components/promotions/promotionsPreview/PromotionPreview'
import PromotionShops from '@/components/promotions/PromotionShops'
import { btnCollapse } from '@/mixins/btnCollapse'
import { PROMO_TYPES } from '@/utils/constants/promo-types'

export default {
    mixins: [btnCollapse],
    data() {
        return {
            step: 1,
            priceTagsOnLoad: null,
            labelsOnLoad: null,
            activeKey: null,
            searchMerchants: null,
            methodSend: !true,
            methodPrint: !false,
            methodText: 'Wyślij',
            allProductsSetsRegularPrice: undefined,
            activeLabelAllProductsHasNotRegularPrice: undefined,
            singleLabelRegularPriceRequestPending: false,
            queueId: null,
            productsFetched: false,
            isFreshProductsPopoverAccept: false,
            isOmnibusPopoverAccept: false,
            unloadedWeightPromos: []
        }
    },

    components: {
        LabelProduct,
        LabelShop,
        UiCheckboxInput,
        PromotionPreview,
        PromotionShops
    },
    computed: {
        acceptLabelsButtonEnabled() {
            if (this.$store.getters.getWalkthroughActive) {
                return true
            }
            const priceTagsAttributes = this.$store.getters.getPriceTagsAttributes || []
            const labelMaxPrice = this.$store.getters.getLabelMaxPrice

            if (priceTagsAttributes.length === 0) {
                return false
            }

            if (priceTagsAttributes.some(e => +e.price_normal > labelMaxPrice)) {
                return false
            }

            if (priceTagsAttributes.some(e => e.promo_dict_product_subscription_id)) {
                return true
            }

            if (priceTagsAttributes.some(e => e.promo_id)) {
                return true
            }

            function isAnyProductChecked(subscription) {
                return subscription.some(({ checked, products }) =>
                    checked && (products || []).some(prod => prod.downloadLabel)
                )
            }

            function hasCheckedProductsInPromo({ subscriptions, subscriptionsEqualPrices }) {
                if (subscriptionsEqualPrices?.equalPrices) {
                    return subscriptionsEqualPrices.priceGroups.some(sub =>
                        isAnyProductChecked(sub)
                    )
                }

                return subscriptions.some(sub => isAnyProductChecked(sub))
            }

            let atLeastOneSubPresent = false
            for (const promoTags of priceTagsAttributes) {
                if (!promoTags.groupId) continue

                const group = this.$store.getters.getSelectedLabelGroup(promoTags.groupId)
                const selectedPromos = group.promos.filter(p => p.selectedToGenerateLabels)
                const totalPromos = +group.pagination.totalRecords
                const excludedPromosCounter = promoTags.excluded_promotions_ids.length

                if (
                    group.selectWholeGroup &&
                    totalPromos - excludedPromosCounter !== selectedPromos.length
                ) {
                    atLeastOneSubPresent = true
                    break
                }

                if (selectedPromos.some(hasCheckedProductsInPromo)) {
                    atLeastOneSubPresent = true
                    break
                }
            }

            return atLeastOneSubPresent
        },
        confirmationWindowConfig() {
            if (this.downloadStatus === 'loading') {
                return {
                    message:
                        'Zamknięcie okna spowoduje przerwanie procesu generowania cenówek',
                    abortButtonText: 'Anuluj',
                    confirmButtonText: 'Przerwij proces',
                    confirmButtonCallback: () => {
                        this.$store.dispatch(
                            'abortLabelsDownload',
                            this.queueId
                        )
                        this.$store.dispatch('toggleModal', false)
                    }
                }
            } else {
                return null
            }
        },
        regularEansPricesActive() {
            return false
        },
        labelGroups() {
            return this.$store.getters.getSelectedLabelGroups
        },
        active() {
            return this.selectedLabels[this.activeKey]
        },
        allLabelsRequestedRegularPrice() {
            return this.selectedLabels.every(
                label => label.regularPricesRequested
            )
        },
        someLabelsHasNotRegularPrice() {
            return this.selectedLabels.some(
                label => label.noRegularPriceInSomeProducts === true
            )
        },
        regularPricesDownloadState() {
            return this.$store.getters.getRegularPricesDownloadState
        },
        noLabelsSelectedInActivePromoText() {
            let text = ''
            if (this.noLabelsSelectedInActivePromo) {
                text = 'Wybierz przynajmniej jeden produkt aby przejść dalej'
            }
            return text
        },
        noLabelsSelectedInActivePromo() {
            if (!this.active) return

            const flag = Object.values(this.active.labels).every(label => {
                return label.downloadLabel === false
            })

            return flag
        },
        labelTypeNormal: {
            get() {
                return this.$store.getters.getLabelGroupsVariant === 'normal'
            },
            set(value) {
                if (value) {
                    this.$store.dispatch('setLabelGroupsVariant', 'normal')
                }
            }
        },
        labelTypeLarge: {
            get() {
                return this.$store.getters.getLabelGroupsVariant === 'large'
            },
            set(value) {
                if (value) {
                    this.$store.dispatch('setLabelGroupsVariant', 'large')
                }
            }
        },
        labelTypeLargeColor: {
            get() {
                return this.$store.getters.getLabelGroupsVariant === 'large2'
            },
            set(value) {
                if (value) {
                    this.$store.dispatch('setLabelGroupsVariant', 'large2')
                }
            }
        },
        labelMerchantHeader: {
            get() {
                return this.$store.getters.getLabelGroupsMerchantHeader
            },
            set(value) {
                this.$store.dispatch('setLabelGroupsMerchantHeader', value)
            }
        },
        labelGuides: {
            get() {
                return this.$store.getters.getLabelGroupsGuides
            },
            set(value) {
                this.$store.dispatch('setLabelGroupsGuides', value)
            }
        },
        selectedLabels() {
            return this.$store.getters.getSelectedLabels
        },
        priceTags() {
            return this.$store.getters.getPriceTags
        },
        downloadStatus() {
            return this.$store.getters.getLabelGroupsDownloadStatus
        },
        merchants() {
            return this.$store.getters.getMerchants
        },
        selectedShopContacts() {
            return this.$store.getters.getLabelsSelectedShopContacts
        },
        enableSendButton() {
            if (this.selectedShopContacts.length > 0) {
                return true
            } else {
                return false
            }
        },

        isWalkThroughActive() {
            return this.$store.getters.getWalkthroughActive
        },
        walkthroughModalLabelsStep() {
            return this.$store.getters.getWalkthroughModalLabelsStep
        },
        isOmnibusConfirm() {
            let displayPopover = false

            function checkProducts(subscriptions, isPriceLowestDiscount) {
                displayPopover = false
                for (const sub of subscriptions) {
                    if (sub.checked && !sub.suspended) {
                        if (sub.products?.length) {
                            for (const product of sub.products) {
                                if (isPriceLowestDiscount) {
                                    if (product.payload) {
                                        const priceLowestDiscount =
                                            product.payload
                                                .price_lowest_discount
                                        if (
                                            product.downloadLabel &&
                                            (!priceLowestDiscount ||
                                                +priceLowestDiscount === 0)
                                        ) {
                                            displayPopover = true
                                        }
                                    } else {
                                        displayPopover = true
                                    }
                                } else {
                                    const priceLowest =
                                        product.priceLowest ||
                                        product.price_lowest
                                    if (
                                        product.downloadLabel &&
                                        (!product.productPrice ||
                                            +product.productPrice === 0 ||
                                            !priceLowest ||
                                            +priceLowest === 0)
                                    ) {
                                        displayPopover = true
                                    }
                                }
                            }
                        } else {
                            displayPopover = true
                        }
                    }
                }
            }

            for (const group of this.labelGroups) {
                for (const promo of group.promos) {
                    if (!promo.selectedToGenerateLabels) continue
                    if (
                        this.isPromosWithMandatoryPriceType(
                            promo.type,
                            promo.loyalty
                        )
                    ) {
                        if (promo.subscriptionsEqualPrices?.equalPrices) {
                            for (const priceGroup of promo
                                .subscriptionsEqualPrices.priceGroups) {
                                checkProducts(
                                    priceGroup,
                                    promo.type ===
                                    PROMO_TYPES.WEIGHT_PERIODIC_PRICE_REDUCTION &&
                                        promo.loyalty
                                )
                            }
                        } else if (promo.subscriptions) {
                            checkProducts(
                                promo.subscriptions,
                                promo.type ===
                                PROMO_TYPES.WEIGHT_PERIODIC_PRICE_REDUCTION &&
                                    promo.loyalty
                            )
                        }
                    }
                }
            }

            return {
                showPopover: displayPopover
            }
        },
        isFreshProductsConfirm() {
            let displayPopover = false
            const store = this.$store
            const errors = []
            const unloadedWeightPromos = this.unloadedWeightPromos
            function checkProducts(subscriptions, promo, priceGroupIdx = 0) {
                for (const sub of subscriptions) {
                    // Sub must be checked and not suspended
                    if (!sub.checked || sub.suspended) {
                        continue
                    }

                    // Display popover if no products
                    const subscriptionProducts = sub.products || []
                    if (!subscriptionProducts.length) {
                        displayPopover = true
                    }

                    for (const product of subscriptionProducts) {
                        const dictProductType = product.dict_product?.dict_product_type
                        const variant = dictProductType?.price_tag_type?.variants?.find(
                            v => v.promo_type === promo.type
                        )

                        if (!product.downloadLabel || !variant?.payload_attributes) {
                            continue
                        }

                        const filteredPayloadAttributes = variant.payload_attributes.filter(
                            e => e.name !== 'price_lowest_discount'
                        )
                        for (const pa of filteredPayloadAttributes) {
                            const findPriceTag = store.getters.getPriceTagsAttributes.find(
                                p => p.subscription_resource_id === product.subscription_resource_id
                            )
                            if (!findPriceTag) {
                                continue
                            }

                            const enteredText =
                                findPriceTag.payload && findPriceTag.payload[pa.name]
                                    ? findPriceTag.payload[pa.name]
                                    : ''

                            if (!enteredText || enteredText === '') {
                                displayPopover = true
                                errors.push({
                                    text: enteredText,
                                    groupId: promo.groupId,
                                    promoId: promo.id,
                                    subscriptionId: sub.id,
                                    merchantId: sub.merchant_id,
                                    productId: product.id,
                                    priceGroupIdx: +priceGroupIdx,
                                    field: pa.name
                                })
                            }
                        }
                    }
                }
            }

            for (const group of this.labelGroups) {
                if (unloadedWeightPromos[group.id]?.length) {
                    displayPopover = true
                } else {
                    for (const promo of group.promos) {
                        if (
                            promo.type ===
                            PROMO_TYPES.WEIGHT_PERIODIC_PRICE_REDUCTION ||
                            promo.type === PROMO_TYPES.WEIGHT_REGULAR_PRICE
                        ) {
                            if (promo.subscriptionsEqualPrices?.equalPrices) {
                                for (const [
                                    priceGroupIdx,
                                    priceGroup
                                ] of Object.entries(
                                        promo.subscriptionsEqualPrices.priceGroups
                                    )) {
                                    checkProducts(
                                        priceGroup,
                                        promo,
                                        priceGroupIdx
                                    )
                                }
                            } else if (promo.subscriptions) {
                                checkProducts(promo.subscriptions, promo)
                            }
                        }
                    }
                }
            }

            return {
                showPopover: displayPopover,
                errors
            }
        },
        confirmMessages() {
            const messages = []
            if (
                this.isFreshProductsConfirm.showPopover &&
                !this.isFreshProductsPopoverAccept
            ) {
                messages.push({
                    message: 'Mam świadomość ryzyka prawnego związanego z brakiem udostępnienia parametrów produktów świeżych',
                    textConfirm: 'Uzupełnij parametry',
                    textAbort: 'Potwierdzam',
                    closeOnConfirmMsg: true,
                    confirmOnAbortMsg: true
                })
            }
            if (this.isOmnibusPopover) {
                if (
                    this.isShopTagServiceActive &&
                    !this.isCancelMandatoryPricePromoGroupsLoad
                ) {
                    let message,
                        textConfirm,
                        textAbort,
                        loadingStatus,
                        hideAbortBtn,
                        hideConfirmBtn,
                        noCloseOnAbort
                    if (
                        this.getPromoGroupsWithMandatoryPriceStatus ===
                        'loading'
                    ) {
                        message = 'Trwa sprawdzanie czy wszystkie ceny zostały uzupełnione...'
                        textAbort = 'Przerwij'
                        loadingStatus = this
                            .getPromoGroupsWithMandatoryPriceStatus
                        hideConfirmBtn = true
                        noCloseOnAbort = true
                    } else if (this.getPromoGroupsWithMandatoryPrice.length) {
                        message = 'Uzupełnij wszystkie ceny z ostatnich 30 dni lub ceny sprzed obniżki oraz ceny poza promocją, a my umieścimy je na materiałach reklamowych'
                        textConfirm = 'Uzupełnij ceny'
                        textAbort = 'Potwierdzam'
                    } else if (this.getMandatoryPriceError) {
                        message = 'Wystąpił błąd'
                        textConfirm = 'Zamknij'
                        hideAbortBtn = true
                    } else {
                        message = 'Wszystkie ceny są uzupełnione!'
                        textConfirm = 'OK'
                        hideAbortBtn = true
                    }
                    messages.push({
                        message,
                        textConfirm,
                        textAbort,
                        loadingStatus,
                        hideAbortBtn,
                        hideConfirmBtn,
                        noCloseOnAbort
                    })
                } else {
                    messages.push({
                        message: `${
                            !this.isOmnibusPopoverAccept ||
                            this.isCancelMandatoryPricePromoGroupsLoad
                                ? 'Upewnij się, że uzupełnione zostały'
                                : 'Uzupełnij'
                        } wszystkie ceny z ostatnich 30 dni lub ceny sprzed obniżki oraz ceny poza promocją, a my umieścimy je na materiałach reklamowych`,
                        textAbort: 'Potwierdzam',
                        textConfirm: 'Uzupełnij ceny'
                    })
                }
            }
            return messages
        },
        unloadedPromosWithMandatoryPrice() {
            const unloadedPromos = []
            const unloadedPromosMandatoryPrice = this.$store.getters
                .getUnloadedPromosMandatoryPrice
            for (const [gKey, promos] of Object.entries(
                unloadedPromosMandatoryPrice
            )) {
                const selectedGroup = this.labelGroups.find(
                    el => +el.id === +gKey
                )
                if (selectedGroup) {
                    for (const promo of promos) {
                        unloadedPromos.push(promo)
                    }
                }
            }
            return unloadedPromos
        },
        isOmnibusPopover() {
            return (
                this.isOmnibusConfirm.showPopover ||
                this.unloadedPromosWithMandatoryPrice.length
            )
        },
        filterSelectedMerchants() {
            return this.$store.getters.getLabelGroupsFilters[
                'promo|subscription|merchant_id'
            ].value
        },
        isShopTagServiceActive() {
            return this.$store.getters.isServiceActive('shop_tag')
        },
        getPromoGroupsWithMandatoryPriceStatus() {
            return this.$store.getters.getMandatoryPricePromoGroupsStatus
        },
        getPromoGroupsWithMandatoryPrice() {
            return this.$store.getters.getMandatoryPricePromoGroups
        },
        getMandatoryPriceValidation() {
            return this.$store.getters.getMandatoryPriceValidation
        },
        isCancelMandatoryPricePromoGroupsLoad() {
            return this.$store.getters.getCancelMandatoryPricePromoGroupsLoad
        },
        getMandatoryPriceError() {
            return this.$store.getters.getMandatoryPricePromoGroupsError
        },
        modalTitle() {
            return this.downloadStatus === 'no_found' ? 'Uwaga!' : 'Generowanie cenówek'
        }
    },
    methods: {
        validateWeightPromos() {
            this.$store.dispatch(
                'openProductsWithErrors',
                this.isFreshProductsConfirm.errors
            )
        },
        arrayEquals(arr1, arr2) {
            if (arr1.length !== arr2.length) {
                return false
            }

            for (let i = 0; i < arr1.length; i++) {
                if (arr1[i] !== arr2[i]) {
                    return false
                }
            }

            return true
        },
        showDownloadMorePromosButton(group) {
            if (
                !group.promosWithEmptyMandatoryPrice ||
                !this.getMandatoryPriceValidation
            ) {
                const groupPromoIds = group.promos
                    .filter(e => e.selectedToGenerateLabels)
                    .filter(e => !e.promoDetailsNotFetched)
                    .map(e => e.id)
                    .sort()
                const selectedPromoIds = group.selectedPromoIds.slice().sort()
                return (
                    group.showPromosOnLabelsGenerateView &&
                    !this.arrayEquals(groupPromoIds, selectedPromoIds)
                )
            } else {
                const groupPromoIds = group.promos
                    .filter(e => e.selectedToGenerateLabels)
                    .filter(e => e.emptyMandatoryPrice)
                    .map(e => e.id)
                    .sort()
                const selectedPromoIds = this.getPromoGroupsWithMandatoryPrice
                    .find(e => e.promo_group_id === group.id)
                    .promos.map(e => e.promo_id)
                    .slice()
                    .sort()
                return (
                    group.showPromosOnLabelsGenerateView &&
                    !this.arrayEquals(groupPromoIds, selectedPromoIds)
                )
            }
        },
        loadMorePromos(group, setPer, setPage) {
            group = JSON.parse(JSON.stringify(group))
            if (
                !group.promosWithEmptyMandatoryPrice ||
                !this.getMandatoryPriceValidation
            ) {
                const per = setPer || 100
                const page = setPage || group.pagination.nextPage || 1

                this.$store.dispatch('loadSelectedLabelPromos', {
                    group,
                    per,
                    page,
                    params: {
                        id: group.selectedPromoIds.join(',')
                    }
                })
            } else {
                const unloadPromoIds = this.getPromoGroupsWithMandatoryPrice.find(
                    e => e.promo_group_id === group.id
                )
                if (unloadPromoIds && group.pagination.nextPage) {
                    this.showValidatedMandatoryPricePromos({
                        group,
                        params: {
                            promo_group_id: group.id,
                            id: unloadPromoIds.promos.map(e => e.promo_id)
                        },
                        page: group.pagination.nextPage
                    })
                }
            }
        },
        onGroupDelete(group) {
            this.$store.dispatch('openConfirmationWindow', {
                message:
                    'Czy na pewno chcesz usunąć całą grupę z procesu generowania cenówek?',
                abortButtonText: 'Zamknij okno',
                confirmButtonText: 'Usuń grupę',
                confirmButtonCallback: () => {
                    this.$store.dispatch('selectLabelPromoGroup', {
                        groupId: group.id,
                        select: false
                    })

                    if (
                        this.$store.getters.getSelectedLabelGroups.length === 0
                    ) {
                        this.$store.dispatch('toggleModal', false)
                    }
                }
            })
        },
        onShowHidePromosClick(group) {
            group.showPromosOnLabelsGenerateView = !group.showPromosOnLabelsGenerateView

            const selectedPromos = group.promos.filter(
                promo => promo.selectedToGenerateLabels
            )
            if (
                group.showPromosOnLabelsGenerateView &&
                selectedPromos.length < group.selectedPromoIds.length &&
                selectedPromos.length < +group.pagination.perPage
            ) {
                this.loadMorePromos(group, 2, 1)
            }
        },

        async onSinglePromoPricesDownload() {
            this.singleLabelRegularPriceRequestPending = true
            await this.$store.dispatch('getRegularEanPrices', this.active)
            this.singleLabelRegularPriceRequestPending = false
        },
        async onPricesDownload() {
            await this.$store.dispatch('getRegularEanPrices')
        },
        goNextBtnHover() {
            if (!this.noLabelsSelectedInActivePromoText) return
            const setProperTooltipPosition = () => {
                const tooltips = Array.from(
                    document.getElementsByClassName('tooltip')
                )

                const activatePromoTooltip = tooltips.find(tooltip => {
                    return tooltip.innerHTML.includes(
                        this.noLabelsSelectedInActivePromoText
                    )
                })
                if (activatePromoTooltip) {
                    const $body = document.querySelector('body')
                    const bodyTop = parseFloat($body.style.top)

                    activatePromoTooltip.style.top = `${-bodyTop}px`
                    clearInterval(interval)
                }
            }
            const interval = setInterval(setProperTooltipPosition, 10)
        },
        setActive(key) {
            this.step = 2
            this.activeKey = key
        },
        saveLabels() {
            if (this.enableSave) {
                this.$store.dispatch('setLabelAccepted', {
                    id: this.active.id,
                    value: true
                })
                this.step = 1
                this.activeKey = null
            }
        },
        async acceptLabels(isLastMsg) {
            if (
                !this.isOmnibusPopover ||
                (this.isOmnibusPopover &&
                    this.isShopTagServiceActive &&
                    this.getPromoGroupsWithMandatoryPriceStatus === 'idle' &&
                    !this.getPromoGroupsWithMandatoryPrice.length)
            ) {
                this.step = 3
            }
            if (this.isOmnibusPopover && !this.isOmnibusPopoverAccept) {
                if (
                    !this.isShopTagServiceActive ||
                    (this.isShopTagServiceActive &&
                        this.isCancelMandatoryPricePromoGroupsLoad &&
                        !this.getPromoGroupsWithMandatoryPrice.length)
                ) {
                    const mandatoryPriceGroups = []
                    for (const [gKey, promos] of Object.entries(
                        this.$store.getters.getUnloadedPromosMandatoryPrice
                    )) {
                        mandatoryPriceGroups.push({
                            promo_group_id: +gKey,
                            promos: promos.map(e => {
                                return {
                                    promo_id: e.id,
                                    merchant_id: []
                                }
                            })
                        })
                    }
                    await this.$store.dispatch(
                        'setMandatoryPriceGroups',
                        mandatoryPriceGroups
                    )
                    this.showValidatedMandatoryPricePromos()
                }
                if (
                    this.isShopTagServiceActive &&
                    this.getPromoGroupsWithMandatoryPrice.length
                ) {
                    this.showValidatedMandatoryPricePromos()
                }
                if (!this.isOmnibusPopoverAccept) {
                    this.isOmnibusPopoverAccept = true
                }
            }
            if (isLastMsg) {
                this.isFreshProductsPopoverAccept = true
                this.isOmnibusPopoverAccept = true
            }
        },
        async abortLabels(isLastMsg) {
            if (
                this.isOmnibusPopover &&
                this.isShopTagServiceActive &&
                this.getPromoGroupsWithMandatoryPriceStatus === 'loading'
            ) {
                await this.$store.dispatch(
                    'setCancelMandatoryPricePromoGroupsLoad',
                    true
                )
                if (this.isFreshProductsConfirm.showPopover) {
                    this.isFreshProductsPopoverAccept = true
                }
            } else if (this.isOmnibusPopover && isLastMsg) {
                this.step = 3
            }
            if (isLastMsg) {
                if (this.isOmnibusPopover) {
                    if (!this.isCancelMandatoryPricePromoGroupsLoad) {
                        this.step = 3
                    }
                    this.isFreshProductsPopoverAccept = true
                    this.isOmnibusPopoverAccept = true
                }
            }
        },
        onChangeMsgIdx() {
            if (
                this.isOmnibusPopover &&
                this.isShopTagServiceActive &&
                !this.isOmnibusPopoverAccept
            ) {
                this.checkPromosWithMandatoryPrice(true)
            }
        },
        checkPromosWithMandatoryPrice(isLastMsg) {
            if (
                isLastMsg &&
                this.isOmnibusPopover &&
                this.isShopTagServiceActive &&
                this.getPromoGroupsWithMandatoryPriceStatus !== 'loading' &&
                !this.getPromoGroupsWithMandatoryPrice?.length
            ) {
                let payload
                const promoIds = []
                const unloadedPromoIdsMandatoryPrice = this.unloadedPromosWithMandatoryPrice.map(
                    el => el.id
                )
                for (const group of this.labelGroups) {
                    const selectedMerchantPromos = group.promos.flatMap(
                        promo => {
                            if (
                                promo.selectedToGenerateLabels &&
                                promo.subscriptions
                            ) {
                                let isUncheckedMerchants = false
                                const merchantIds = promo.subscriptions
                                    .filter(e => {
                                        if (
                                            !e.suspended &&
                                            !e.checked &&
                                            e.state === 'accepted'
                                        ) {
                                            isUncheckedMerchants = true
                                        }
                                        return e.checked && !e.suspended
                                    })
                                    .map(sub => sub.merchant_id)
                                if (
                                    isUncheckedMerchants ||
                                    (this.filterSelectedMerchants?.length &&
                                        !(
                                            merchantIds.every(id =>
                                                this.filterSelectedMerchants.includes(
                                                    id
                                                )
                                            ) &&
                                            !this.filterSelectedMerchants.every(
                                                id => merchantIds.includes(id)
                                            )
                                        ))
                                ) {
                                    return {
                                        id: promo.id,
                                        merchant_ids: merchantIds
                                    }
                                } else {
                                    return []
                                }
                            } else {
                                return []
                            }
                        }
                    )
                    promoIds.push(...selectedMerchantPromos)
                    const promosData = group.selectedPromoIds
                        .filter(el => {
                            return !promoIds.map(v => v.id).includes(el) &&
                            unloadedPromoIdsMandatoryPrice.includes(el)
                        })
                        .map(el => {
                            return {
                                id: el
                            }
                        })
                    promoIds.push(...Object.values(promosData))
                    payload = {
                        promo_ids: promoIds
                    }
                }
                this.$store.dispatch('fetchMandatoryPricePromoGroups', payload)
            }
        },
        downloadLabels() {
            this.queueId = Date.now()
            this.$store.dispatch('downloadLabelGroups', {
                methodSend: this.methodSend ? 'send' : 'print',
                queueId: this.queueId
            })
        },
        async sendLabels() {
            if (this.enableSendButton) {
                try {
                    await this.$store.dispatch('sendLabelGroups')
                    this.step = 5
                } catch (err) {
                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        content:
                            'Wystąpił błąd. Nie udało się wysłać cenówek. Spróbuj ponownie później. '
                    })
                }
            }
        },
        deselectLabel(promoId) {
            this.$store.dispatch('slectLabelGroupLabel', {
                id: promoId
            })
        },
        cancel() {
            if (this.step === 2) {
                this.step = 1

                if (this.active && this.active.accepted) {
                    this.$store.dispatch(
                        'restoreSelectedLabels',
                        this.labelsOnLoad
                    )
                }

                this.singleLabelRegularPriceRequestPending = false
                this.activeKey = null
                this.$store.dispatch('restorePriceTags', this.priceTagsOnLoad)
            }
            this.$store.dispatch('resetPromoGroupsWithMandatoryPriceStatus')
            this.$store.dispatch('setUnloadedWeightPromos', [])
            this.$store.dispatch('resetDownloadLabelGroupsStatus')
            this.$store.dispatch('toggleModal', false)
        },
        chooseSend() {
            this.step = 4
            this.$store.dispatch('labelsShopsContactsFetch')
        },
        selectAllShops(value) {
            this.$store.dispatch('selectAllShopContacts', value)
        },
        async checkUnloadedPromos() {
            const groups = this.labelGroups
            const unloadedPromos = {}
            const unloadedWeightPromos = []

            for (const group of groups) {
                const promoTypes = await this.$store.dispatch(
                    'promoGroupTypesFetch',
                    {
                        promo_group_id: group.id,
                        type:
                            `${PROMO_TYPES.MIX1},${PROMO_TYPES.WEIGHT_PERIODIC_PRICE_REDUCTION},${PROMO_TYPES.PERIODIC_PRICE_REDUCTION},${PROMO_TYPES.WEIGHT_REGULAR_PRICE},${PROMO_TYPES.PROMO_ITEM_FIXED_PRICE}`,
                        state: 'active',
                        'subscription|state': 'accepted',
                        'subscription|merchant_id': this.$store.getters.getAvailableMerchants
                            .map(el => el.id)
                            .join()
                    }
                )
                if (!promoTypes?.data) continue
                // check unloaded promos with mandatory price
                unloadedPromos[group.id] = []
                for (const [type, tValue] of Object.entries(promoTypes.data)) {
                    unloadedPromos[group.id].push(
                        ...tValue.filter(
                            promo =>
                                this.isPromosWithMandatoryPriceType(
                                    type,
                                    promo.loyalty
                                ) &&
                                ((group.selectWholeGroup &&
                                    group.selectedPromoIds.includes(
                                        promo.id
                                    )) ||
                                    (!group.selectWholeGroup &&
                                        group.promos
                                            .filter(
                                                e => e.selectedToGenerateLabels
                                            )
                                            .map(e => e.id)
                                            .includes(promo.id)))
                        )
                    )
                }
                if (unloadedPromos[group.id].length === 0) {
                    delete unloadedPromos[group.id]
                }
                // check unloaded Weight promos
                unloadedWeightPromos[group.id] = []
                for (const [tKey, tValue] of Object.entries(promoTypes.data)) {
                    if (
                        tKey === PROMO_TYPES.WEIGHT_REGULAR_PRICE ||
                        tKey === PROMO_TYPES.WEIGHT_PERIODIC_PRICE_REDUCTION
                    ) {
                        const promoData = tValue
                            .filter(promo =>
                                group.selectedPromoIds.includes(promo.id)
                            )
                            .map(v => {
                                return {
                                    ...v,
                                    type: tKey
                                }
                            })
                        unloadedWeightPromos[group.id].push(...promoData)
                    }
                }
                if (unloadedWeightPromos[group.id].length === 0) {
                    delete unloadedWeightPromos[group.id]
                }
            }
            this.$store.dispatch(
                'setUnloadedPromosWithMandatoryPrice',
                unloadedPromos
            )
            if (Object.keys(unloadedWeightPromos)?.length) {
                this.unloadedWeightPromos = unloadedWeightPromos
            }
        },
        collapseGroup(group) {
            group.showPromosOnLabelsGenerateView = false
        },
        onHandleBtnCollapse() {
            document.querySelectorAll('.t-promo-group').forEach(el => {
                this.handleBtnCollapse(el)
            })
        },

        async downloadProducts() {
            const groups = this.$store.getters.getSelectedLabelGroups

            for (const group of groups) {
                for (const promo of group.promos) {
                    const { subscriptions, selectedToGenerateLabels } = promo

                    /**
                     * Skip if subscriptions exist or the promo
                     * is not selected for generating labels
                     */
                    if (subscriptions || !selectedToGenerateLabels) {
                        continue
                    }

                    // Fetch products for the current promo
                    await this.$store.dispatch('fetchProductsByPromoLabel', {
                        selectedLabels: true,
                        promoId: promo.id,
                        groupId: group.id
                    })
                }
            }
        },

        isPromosWithMandatoryPriceType(promoType, loyalty) {
            return (
                promoType === PROMO_TYPES.MIX1 ||
                promoType === PROMO_TYPES.PROMO_ITEM_FIXED_PRICE ||
                (promoType === PROMO_TYPES.PERIODIC_PRICE_REDUCTION && loyalty) ||
                (promoType === PROMO_TYPES.WEIGHT_PERIODIC_PRICE_REDUCTION && loyalty)
            )
        },
        async showValidatedMandatoryPricePromos(payload) {
            if (!payload) {
                await this.$store.commit(
                    'SET_MANDATORY_PRICE_VALIDATION',
                    false
                )
                this.productsFetched = false
            }
            const fetchProducts = async (group, promo) => {
                const { productSets: sets, id: promoId } = promo

                return await this.$store.dispatch(
                    'fetchProductsByPromoLabel',
                    {
                        per: 100,
                        main: true,
                        groupId: group.id,
                        promoId,
                        productSetId: sets && sets[0] && sets[0].id,
                        promo,
                        selectedLabels: true
                    }
                )
            }
            const showDetails = async (group, promo) => {
                if (!group.showPromosOnLabelsGenerateView) {
                    group.showPromosOnLabelsGenerateView = true
                }
                if (
                    !promo.showMore &&
                    promo.emptyMandatoryPrice &&
                    this.isShopTagServiceActive
                ) {
                    this.$set(promo, 'showMore', true)
                }
            }

            // fetch all promos with mandatory price
            for (const group of this.getPromoGroupsWithMandatoryPrice) {
                const selectedGroup = this.$store.getters.getSelectedLabelGroup(
                    group.promo_group_id
                )
                await this.$store.dispatch(
                    'toggleMandatoryPricePromos',
                    payload || {
                        group: selectedGroup,
                        params: {
                            promo_group_id: group.promo_group_id,
                            id: group.promos.map(e => e.promo_id)
                        },
                        page: 1
                    }
                )
                // fetch products
                for (const promo of selectedGroup.promos.filter(
                    promo => promo.selectedToGenerateLabels
                )) {
                    if (
                        this.isShopTagServiceActive &&
                        !promo.products?.length &&
                        !promo.product_sets?.length
                    ) {
                        await fetchProducts(selectedGroup, promo)
                    }
                }
            }

            // expand all promos with mandatory price
            for (const group of this.getPromoGroupsWithMandatoryPrice) {
                const selectedGroup = this.$store.getters.getSelectedLabelGroup(
                    group.promo_group_id
                )
                for (const promo of selectedGroup.promos) {
                    await showDetails(selectedGroup, promo)
                }
            }
            this.$store.commit('SET_SELECTED_LABELGROUPS', this.labelGroups)
            if (!payload) {
                await this.$store.commit('SET_MANDATORY_PRICE_VALIDATION', true)
                this.productsFetched = true
            }
        },
        filteredSelectedLabels(group) {
            if (
                group.promosWithEmptyMandatoryPrice &&
                this.getMandatoryPriceValidation
            ) {
                return group.promos.filter(
                    promo =>
                        promo.emptyMandatoryPrice &&
                        promo.selectedToGenerateLabels
                )
            } else {
                return group.promos.filter(
                    promo => promo.selectedToGenerateLabels
                )
            }
        },
        showMandatoryPriceGroupWarning(group) {
            return (
                this.getMandatoryPriceValidation &&
                group.promosWithEmptyMandatoryPrice
            )
        },
        formatCheckboxTooltipText(type) {
            const enabledTypes = this.$store.getters.getEnableTypesPromoByLabelFormat(type)
            if (!enabledTypes?.length) return

            const disabledTypes = this.$store.getters.getPromoTypes
                .filter(({ type }) => enabledTypes.includes(type))
                .map(({ name }) => `<li>${name}</li>`)
                .join('')

            return `
                <p class="text-left mb-0 font-weight-bold">Niedostępne dla poniższych typów promocji:</p>
                <ul class="text-left">
                    ${disabledTypes}
                </ul>
            `
        }
    },
    watch: {
        walkthroughModalLabelsStep: {
            immediate: true,
            handler(val) {
                if (this.isWalkThroughActive) {
                    this.step = val
                }
            }
        },
        step() {
            if (this.step === 2) {
                this.priceTagsOnLoad = JSON.parse(
                    JSON.stringify(this.priceTags)
                )
                this.labelsOnLoad = JSON.parse(
                    JSON.stringify(this.selectedLabels)
                )
            } else if (this.step === 1) {
                this.isOmnibusPopoverAccept = false
            }
        },
        methodSend() {
            this.methodPrint = !this.methodSend
            this.methodPrint
                ? (this.methodText = 'Drukuj')
                : (this.methodText = 'Wyślij')
        },
        methodPrint() {
            this.methodSend = !this.methodPrint
        },

        active: {
            deep: true,
            handler(value) {
                if (!value) return
                this.activeLabelAllProductsHasNotRegularPrice =
                    value.noRegularPriceInAllProducts

                let allProductsSetsRegularPrice = true

                if (!value.labels) return
                Object.values(value.labels).forEach(product => {
                    Object.values(product.subscriptions).forEach(
                        subscription => {
                            if (
                                subscription.regular_price === undefined ||
                                (subscription.regular_price !== null &&
                                    subscription.regular_price !==
                                        subscription.price_normal)
                            ) {
                                allProductsSetsRegularPrice = false
                            }
                        }
                    )
                })

                this.allProductsSetsRegularPrice = allProductsSetsRegularPrice
            }
        }
    },
    async created() {
        if (
            !this.$store.getters.getServices ||
            !this.$store.getters.getServices.length
        ) {
            this.$store.dispatch('servicesFetch')
        }
        await this.downloadProducts()
        this.productsFetched = true

        this.checkUnloadedPromos()
    },
    mounted() {
        this.onHandleBtnCollapse()

        this.$nextTick(() => {
            const modalContent = document.querySelector(
                '.modal--accept .modal-body'
            )

            modalContent.addEventListener('scroll', () => {
                this.onHandleBtnCollapse()
            })
        })
    }
}
</script>

<style lang="scss">
.m-modalPromoAccept__groupHeader {
    &.--labels {
        display: flex;
        justify-content: space-between;
        width: 100%;
        gap: 1rem;
        align-items: center;
    }
}

.m-labels {
    &__labelHeader {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    &__regularPriceWrapper {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
}
</style>